import legitimizerAPI from '../api';
import { KycIdentificationProvider } from '../types';

export const getIdentityVerificationURL = async (
  authorizeMethodURL: string,
  currentLanguageKey: string,
  identityProvider: KycIdentificationProvider,
  successRedirectURL: string,
): Promise<string> => {
  const redirectURI = `${process.env.LEGITIMIZER_OIDC_REDIRECT_URI}/${successRedirectURL}`;

  const params = new URLSearchParams({
    redirect_uri: redirectURI,
    language: currentLanguageKey,
    provider: identityProvider,
    profile: 'default',
  });

  const {
    data: { authorizeUrl },
  } = await legitimizerAPI.get(authorizeMethodURL, {
    params,
  });

  return authorizeUrl;
};
